export default function sanitizeQueryParam(value:string) {
    return value
        .replace(/--/g, "")
        .replace(/</g, "")
        .replace(/>/g, "")
        .replace(/\(\s/g, "")
        .replace(/eval\((.*)\)/gi, "")
        .replace(/\\['"]\s*javascript:(.*)\\['"]/gi, "")
        .replace(/\\sscript\\s/gi, "");
}